import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import Pagination from '@atlaskit/pagination';
var ManagedPagination = /*#__PURE__*/function (_React$Component) {
  _inherits(ManagedPagination, _React$Component);
  var _super = _createSuper(ManagedPagination);
  function ManagedPagination() {
    var _this;
    _classCallCheck(this, ManagedPagination);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onChange", function (_event, newValue, analyticsEvent) {
      _this.props.onChange(newValue, analyticsEvent);
    });
    return _this;
  }
  _createClass(ManagedPagination, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        total = _this$props.total,
        _this$props$value = _this$props.value,
        value = _this$props$value === void 0 ? 1 : _this$props$value,
        i18n = _this$props.i18n,
        testId = _this$props.testId,
        isDisabled = _this$props.isDisabled;
      var pages = _toConsumableArray(Array(total)).map(function (_, index) {
        return index + 1;
      });
      // Pagination accepts array now thus selectedIndex starts with 0
      // So, we are substracting value by one thus not breaking dynamic table
      var selectedIndex = value - 1;
      return /*#__PURE__*/React.createElement(Pagination, {
        selectedIndex: selectedIndex,
        isDisabled: isDisabled,
        label: i18n === null || i18n === void 0 ? void 0 : i18n.label,
        nextLabel: i18n === null || i18n === void 0 ? void 0 : i18n.next,
        previousLabel: i18n === null || i18n === void 0 ? void 0 : i18n.prev,
        pageLabel: i18n === null || i18n === void 0 ? void 0 : i18n.pageLabel,
        onChange: this.onChange,
        pages: pages,
        testId: testId && "".concat(testId, "--pagination")
      });
    }
  }]);
  return ManagedPagination;
}(React.Component);
export { ManagedPagination as default };